module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65405149","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/ErrorLabel.vue
// module id = 212
// module chunks = 14